'use client';

import * as React from 'react';
export const CalendarGridTimeColumnContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridTimeColumnContext.displayName = "CalendarGridTimeColumnContext";
export function useCalendarGridTimeColumnContext() {
  const context = React.useContext(CalendarGridTimeColumnContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `CalendarGridTimeColumnContext` is missing. <CalendarGrid.TimeEvent /> must be placed within <CalendarGrid.TimeColumn />.');
  }
  return context;
}